import { css } from '@linaria/core';

export const rootClassname = css`
  margin: 0;
  position: relative;
  font-family: inherit;
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
  padding: 13px 24px;
  border-radius: 0;
  background: #fff;
  color: #000;
  border: 1px solid #000000;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background-color: #747474;
    color: #2a2a2a;
    cursor: not-allowed;
    border-color: #747474;
  }

  width: 100%;
`;

export const actionClassname = css`
  border: none;
  background-color: #f8f8f8;

  &:hover {
    background-color: rgba(0, 0, 0, 0.09);
  }
`;

export const iconClassname = css`
  background-color: transparent;
  border: none;

  &:hover {
    background-color: transparent;
  }
`;

export const classnamesByType = {
  primary: css`
    background: #000;
    color: #fff;

    &:hover {
      background-color: rgba(0, 0, 0, 0.85);
    }
  `,
  secondary: css`
    background: #f2f2f2;
    border-color: #f2f2f2;
    color: #000;

    &:hover {
      background-color: rgb(242, 242, 242, 0.85);
    }
  `,
  text: css`
    background-color: transparent;
    border: none;
    color: #006CFF;

    &:hover {
      background-color: transparent;
    }
  `,
  live: css`
    background: #e12147;
    border-color: #e12147;
    color: #fff;

    &:hover {
      background-color: rgb(225, 33, 71, 0.85);
    }
  `,
  action: actionClassname,
  icon: iconClassname,
};

export const contentClassname = css`
  align-items: center;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;

export const contentButtonAsText = css`
  justify-content: flex-start;
`;

export const iconWithContent = css`
  margin: -8px 8px -8px -8px;
`;

export const iconWithoutContent = css`
  padding: 0;
`;

export const sizeM = css`
  width: 136px;
`;

export const sizeS = css`
  width: 78px;
`;

export const sizeSquare = css`
  width: 48px;
  height: 48px;
`;

export const smallSquare = css`
  width: 24px;
  height: 24px;
`;
